import { render } from "./contact.vue?vue&type=template&id=414708a1&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=414708a1&lang=less&scoped=true"
import "./contact.vue?vue&type=style&index=1&id=414708a1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414708a1"]])

export default __exports__